import * as React from 'react';

const useMq = (query: string) => {
  const mq = window.matchMedia(query);

  const [matches, setMatches] = React.useState(mq.matches);

  mq.addEventListener('change', (ev) => {
    setMatches(ev.matches);
  });

  return matches;
};

export default useMq;
